var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Upload"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Upload",
    clipPath: "url(#clip-Upload)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload_1_",
    "data-name": "upload (1)",
    transform: "translate(-79.207 -80.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18945",
    "data-name": "Path 18945",
    d: "M89.2,280.546c-1.766,0-3.531,0-5.3,0a4.09,4.09,0,0,1-3.923-2.619,4.243,4.243,0,0,1-.254-1.312c-.035-1.176-.015-2.354-.012-3.531a.809.809,0,0,1,.517-.793.84.84,0,0,1,.907.129.816.816,0,0,1,.3.673q0,1.7,0,3.394a2.366,2.366,0,0,0,2.475,2.391H94.491a2.366,2.366,0,0,0,2.482-2.4c0-1.138,0-2.276,0-3.414a.859.859,0,0,1,1.53-.521.943.943,0,0,1,.188.5c.007,1.3.04,2.6-.028,3.9a3.991,3.991,0,0,1-3.7,3.577c-.7.044-1.414.027-2.121.03C91.627,280.549,90.414,280.546,89.2,280.546Z",
    transform: "translate(0 -181.047)",
    fill: "#0071cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18946",
    "data-name": "Path 18946",
    d: "M151.015,83.358v.282q0,5.044,0,10.088a.844.844,0,0,1-.688.915.867.867,0,0,1-1.06-.729c-.008-.091-.006-.182-.006-.273q0-5,0-9.991v-.286c-.089.077-.146.124-.2.174q-1.759,1.662-3.516,3.325a.921.921,0,0,1-.855.277.815.815,0,0,1-.486-1.358c.04-.044.085-.085.129-.126l5.092-4.815a.925.925,0,0,1,1.419-.006q2.561,2.421,5.122,4.842a.829.829,0,0,1,.3.826.89.89,0,0,1-1.471.42c-.423-.382-.829-.78-1.242-1.171l-2.349-2.221C151.159,83.484,151.108,83.441,151.015,83.358Z",
    transform: "translate(-60.93)",
    fill: "#0071cd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.6b7dddc719a8b6461d0c606e0b69dd47.svg";
export { ForwardRef as ReactComponent };